/* tslint:disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AdvertisementsService } from './services/advertisements.service';
import { AuthService } from './services/auth.service';
import { CityService } from './services/city.service';
import { CompanyUnitsService } from './services/company-units.service';
import { ConfigService } from './services/config.service';
import { ContactService } from './services/contact.service';
import { DictionaryService } from './services/dictionary.service';
import { EmployerRelationshipsService } from './services/employer-relationships.service';
import { EmployersService } from './services/employers.service';
import { EnumHelpersService } from './services/enum-helpers.service';
import { EventService } from './services/event.service';
import { I18NService } from './services/i-18-n.service';
import { LabelsService } from './services/labels.service';
import { PermissionsService } from './services/permissions.service';
import { PreferenceService } from './services/preference.service';
import { ProfileService } from './services/profile.service';
import { RegistrationService } from './services/registration.service';
import { RoleService } from './services/role.service';
import { SettingsService } from './services/settings.service';
import { UserService } from './services/user.service';
import { UserCardFieldsService } from './services/user-card-fields.service';
import { UserCardRolesService } from './services/user-card-roles.service';
import { UserImagesService } from './images/user-images-service';
import { UserServiceFormdata } from './userervice.formdata/userservice.formdata';
import { ExportService } from './export/export.service';
import { EventStatisticsService } from './services/event-statistics.service';
import { StatisticsService } from './services/statistics.service';
import { BackgroundEventService } from './background-event/background-event.service';
import { BackgroundEventUserService } from './background-event/background-eventuser.service';
import { LogEventService } from './services/log-event.service';
import { WageCalculationService } from './services/wage-calculation.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AdvertisementsService,
    AuthService,
    CityService,
    CompanyUnitsService,
    ConfigService,
    ContactService,
    DictionaryService,
    EmployerRelationshipsService,
    EmployersService,
    EnumHelpersService,
    EventService,
    EventStatisticsService,

    I18NService,
    LabelsService,
    PermissionsService,
    PreferenceService,
    ProfileService,
    RegistrationService,
    RoleService,
    SettingsService,
    StatisticsService,

    UserService,
    UserCardFieldsService,
    UserCardRolesService,
    UserImagesService,
    ExportService,
    UserServiceFormdata,
    ApiConfiguration,
    BackgroundEventService,
    BackgroundEventUserService,
    LogEventService,
    WageCalculationService
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
